import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ResultItemShow from './components/ResultItemShow';
import styled from 'styled-components';
import { Card } from './sectionInfo';
import { ResultHeaders } from './sectionOpeningResult';
import { UITable } from 'components/bases/UI/Table';
import Pagination from '@components/pagination';
import { pageSize } from '.';
const SectionFinishResult = ({ dataShow, isDetail }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const { t } = useTranslation();
  const topic3 = useSelector((state) => state.result.result.topic3);
  dataShow.sort((a, b) => {
    if (a && b && a.topic && b.topic && a.topic.order > b.topic.order) {
      return 1;
    } else if (a && b && a.topic && b.topic && a.topic.order < b.topic.order) {
      return -1;
    }
    return 0;
  });
  if (topic3)
    topic3.sort((a, b) => {
      if (a && b && a.order > b.order) {
        return 1;
      } else if (a && b && a.order < b.order) {
        return -1;
      }
      return 0;
    });
  // topic3.sort((a, b) => {
  //   let createA = new Date(a.createdAt).getTime();
  //   let createB = new Date(b.createdAt).getTime();
  //   if (createA > createB) {
  //     return 1;
  //   } else if (createA < createB) {
  //     return -1;
  //   }
  //   return 0;
  // });

  if (isDetail)
    return (
      <Styles2 header={t('Thủ tục bế mạc')} isDetail>
        {(topic3 || []).map((item, index) => {
          return (
            <ResultItemShow
              key={index}
              index={index}
              topic={item}
              isDetail={true}
            />
          );
        })}
      </Styles2>
    );

  return (
    <Styles
      header={t('Thủ tục bế mạc')}
      label={t('Kết quả biểu quyết tại Đại hội')}
    >
      <UITable
        items={topic3.slice(
          (currentPage - 1) * pageSize,
          currentPage * pageSize,
        )}
        customHeader={<ResultHeaders />}
      >
        {(item, ind) => {
          const index = currentPage * pageSize - pageSize + ind;
          return <ResultItemShow key={index} index={index} topic={item} />;
        }}
      </UITable>
      <div className="pagination-cover">
        <Pagination
          // handleChangePageSize={getPageSize}
          hideSelectSize={true}
          current={currentPage}
          total={topic3.length}
          pageSize={pageSize}
          onChange={(page) => {
            setCurrentPage(page);
          }}
        />
      </div>
    </Styles>
  );
};

export default SectionFinishResult;

const Styles = styled(Card)`
  margin: 32px 0;
  p {
    color: ${(props) => props.theme.textColor || ''};
  }
`;

const Styles2 = styled(Card)`
  margin: 32px 0;
  h2,
  p {
    color: #3f475e;
  }
`;
